export interface FAQItem {
    question: string;
    answer: string;
}

export const FAQData: FAQItem[] = [
    {
        question: 'How to select and purchase a template?',
        answer: 'View all our templates and read through the descriptions for each template to make a choice. Click on Free or Buy to proceed to the next step. You will then be guided through our current purchasing process.',
    },
    {
        question: 'How to create a project?',
        answer: 'Add your project name, insert the address or choose your project address on the map and proceed to the next step.',
    },
    {
        question: 'How to add your measurements?',
        answer: 'Always add all your measurements in meters in the fields required.',
    },
    {
        question: 'How to amend your products?',
        answer: 'Select the edit pen next to the products to change to different products in your Cashbuild store.',
    },
    {
        question: 'How to purchase products as required?',
        answer: 'Click on Select products to add to cart, then tick the boxes of the products you need. Click on next and then you can add the quantities you require. and proceed to check out.',
    },
    {
        question: 'How to download PDF of BOM?',
        answer: 'Click on Download PDF and it will be downloaded on to your device.',
    },
    {
        question: 'How Labour is calculated?',
        answer: 'Labour prices are based on current fair market rates and may vary depending on project complexity, location, and material availability.',
    },
];
